import _ from 'lodash';
import React from 'react';
import { md, renderMarkdown } from '@achievable-me/tundra-wizard/markdown';
import MarkdownHtml from '$components/MarkdownHtml';
import history from '$lib/history';
import markdownItRelativeLink from './markdown/relativeLink';

window.relativeNavigateTo = (path) => {
  history.push(path);
  return false;
};

md.use(markdownItRelativeLink, {
  navigateToFuncName: 'window.relativeNavigateTo',
});

export const markdownToHtml = (markdown) => {
  if (!markdown) {
    return null;
  }

  const rendered = md.render(markdown.toString());
  const markdownHtml = <MarkdownHtml jsx={rendered} />;

  return markdownHtml;
};

export const parseMarkdown = (markdown, extra) => {
  if (!markdown || _.isEmpty(markdown)) {
    return null;
  }

  const fragmentUuid = _.get(extra, 'fragmentUuid', 'default');
  const isStaff = _.get(extra, 'isStaff', false);

  const { rendered, markdownText, markdownTextSingleLine, markdownTextSnippet } =
    renderMarkdown(markdown);

  const markdownHtml = (
    <MarkdownHtml fragmentUuid={fragmentUuid} isStaff={isStaff} jsx={rendered} enhanced />
  );

  return {
    markdownHtml,
    markdownText,
    markdownTextSingleLine,
    markdownTextSnippet,
  };
};
